import { useLocation, useNavigate } from 'react-router-dom';
import type { AccountDeletedState } from './DeleteAccount';
import { Banner } from './ui';

/** What the front page shows after this device signed out everywhere: how many devices were signed out. */
export interface SignedOutEverywhereState {
  signedOutEverywhere: number;
}

/**
 * Says what has just happened to the account on the screen a person lands on
 * afterwards (the front page, or the sign-in screen in the apps): it was
 * deleted, or every device was signed out. It stays until dismissed.
 */
export function AccountNotice() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as Partial<AccountDeletedState & SignedOutEverywhereState> | null;
  const dismiss = (
    <button className="btn" onClick={() => navigate(`${location.pathname}${location.search}`, { replace: true, state: null })}>
      Dismiss
    </button>
  );
  if (state?.accountDeleted) {
    return (
      <Banner tone="info" title="Your account was deleted" testId="account-deleted" action={dismiss}>
        {state.accountDeleted.emailed ? 'We’ve emailed you a confirmation. ' : ''}Signing in again creates a new, empty account.
      </Banner>
    );
  }
  if (typeof state?.signedOutEverywhere === 'number') {
    const n = state.signedOutEverywhere;
    return (
      <Banner tone="info" title="You’re signed out everywhere" testId="signed-out-everywhere" action={dismiss}>
        {n > 1 ? `${n} devices were signed out, this one included. Each has to sign in again to use your account.` : 'This was the only device signed in to your account.'}
      </Banner>
    );
  }
  return null;
}
